import { render, staticRenderFns } from "./demandEdit.vue?vue&type=template&id=4363b1a4"
import script from "./demandEdit.vue?vue&type=script&lang=js"
export * from "./demandEdit.vue?vue&type=script&lang=js"
import style0 from "./demandEdit.vue?vue&type=style&index=0&id=4363b1a4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports